import { createSlice } from "@reduxjs/toolkit";

const billingSlice = createSlice({
    name: 'billing',
    initialState: {
        loading: false,
        bills: [],
        summary: { totalBilled: 0, totalPaid: 0, totalDue: 0 },
        bill: {},
        isBillCreated: false,
        isBillUpdated: false,
        isBillDeleted: false,
        isPaymentAdded: false
    },
    reducers: {
        billingRequest(state, action) {
            return {
                ...state,
                loading: true
            }
        },
        patientBillsSuccess(state, action) {
            return {
                ...state,
                loading: false,
                bills: action.payload.bills,
                summary: action.payload.summary
            }
        },
        allBillsSuccess(state, action) {
            return {
                ...state,
                loading: false,
                bills: action.payload.bills
            }
        },
        billingFail(state, action) {
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        },
        clearBillingError(state, action) {
            return {
                ...state,
                error: null
            }
        },
        singleBillSuccess(state, action) {
            return {
                ...state,
                loading: false,
                bill: action.payload.bill
            }
        },
        newBillSuccess(state, action) {
            const newBill = action.payload.bill;
            const updatedBills = newBill
                ? [newBill, ...state.bills.filter(b => String(b._id || b.id) !== String(newBill._id || newBill.id))]
                : state.bills;
            return {
                ...state,
                loading: false,
                bill: newBill,
                bills: updatedBills,
                isBillCreated: true
            }
        },
        clearBillCreated(state, action) {
            return {
                ...state,
                isBillCreated: false
            }
        },
        updateBillSuccess(state, action) {
            const updatedBill = action.payload.bill;
            const updatedBills = updatedBill
                ? state.bills.map(b => String(b._id || b.id) === String(updatedBill._id || updatedBill.id) ? updatedBill : b)
                : state.bills;
            return {
                ...state,
                loading: false,
                bill: updatedBill,
                bills: updatedBills,
                isBillUpdated: true
            }
        },
        clearBillUpdated(state, action) {
            return {
                ...state,
                isBillUpdated: false
            }
        },
        paymentAddedSuccess(state, action) {
            const updatedBill = action.payload.bill;
            const updatedBills = updatedBill
                ? state.bills.map(b => String(b._id || b.id) === String(updatedBill._id || updatedBill.id) ? updatedBill : b)
                : state.bills;
            return {
                ...state,
                loading: false,
                bill: updatedBill,
                bills: updatedBills,
                isPaymentAdded: true
            }
        },
        clearPaymentAdded(state, action) {
            return {
                ...state,
                isPaymentAdded: false
            }
        },
        deleteBillSuccess(state, action) {
            return {
                ...state,
                loading: false,
                isBillDeleted: true
            }
        },
        clearBillDeleted(state, action) {
            return {
                ...state,
                isBillDeleted: false
            }
        },
        clearBill(state, action) {
            return {
                ...state,
                bill: {}
            }
        }
    }
});

const { actions, reducer } = billingSlice;

export const {
    billingRequest,
    patientBillsSuccess,
    allBillsSuccess,
    billingFail,
    clearBillingError,
    singleBillSuccess,
    newBillSuccess,
    clearBillCreated,
    updateBillSuccess,
    clearBillUpdated,
    paymentAddedSuccess,
    clearPaymentAdded,
    deleteBillSuccess,
    clearBillDeleted,
    clearBill
} = actions;

export default reducer;
